export default {
    "请选择状态": "请选择状态",
    "订阅": "订阅",
    "进入直播间": "进入直播间",
    "进入回看": "进入回看",
    "订阅成功": "订阅成功",
    "订阅直播": "订阅直播",
    "直播详情页": "直播详情页",
    "嘉宾": "嘉宾",
    "直播嘉宾": "直播嘉宾",
    "直播详情": "直播详情",
    "直播合作": "直播合作",
    "已订阅": "已订阅",
    "直播中": "直播中",
    "即将开始": "即将开始",
    "推荐直播": "推荐直播",
    "取消订阅成功": "取消订阅成功",
    "您已成功订阅直播提醒，直播开始前15分钟将通过短信、服务号及App推送通知。": "您已成功订阅直播提醒，直播开始前15分钟将通过短信、服务号及App推送通知。",
    "您已成功取消订阅直播提醒，将不再收到该直播开始的通知。": "您已成功取消订阅直播提醒，将不再收到该直播开始的通知。",
    "取消订阅": "取消订阅",
    "参与的直播": "参与的直播",
    "还没有参与的直播": "还没有参与的直播",
    "直播预告": "直播预告",
    "TA正在直播": "TA正在直播",
    "开播前短信/服务号/App通知": "开播前短信/服务号/App通知",

    "我的订单": "我的订单",
    "订单详情": "订单详情",
    "立即购买": "立即购买",
    "商品": "商品",
    "单价(元)": "单价(元)",
    "实付金额(元)": "实付金额(元)",
    "交易状态": "交易状态",
    "操作": "操作",
    "订单编号": "订单编号",
    "直播": "直播",
    "去支付": "去支付",
    "取消订单": "取消订单",
    "申请售后": "申请售后",
    "请联系网站底部在线客服或服务热线": "请联系网站底部在线客服或服务热线",
    "是否取消该订单？": "是否取消该订单？",
    "是": "是",
    "否": "否",
    "全部": "全部",
    "待支付": "待支付",
    "已支付": "已支付",
    "已退款": "已退款",
    "已取消": "已取消",
    "确认订单": "确认订单",
    "商品详情": "商品详情",
    "价格": "价格",
    "开始时间": "开始时间",
    "总计": "总计",
    "支付方式": "支付方式",
    "立即支付": "立即支付",
    "提交订单即表示您已同意": "提交订单即表示您已同意",
    "《吗呐平台商品交易服务协议》": "《吗呐平台商品交易服务协议》",
    "请在": "请在",
    "内完成支付": "内完成支付",
    "支付成功": "支付成功",
    "后自动进入直播间": "后自动进入直播间",
    "查看订单": "查看订单",
    "微信付款": "微信付款",
    "实付金额": "实付金额",
    "请在15分钟内完成付款": "请在15分钟内完成付款",
    "请使用微信扫一扫": "请使用微信扫一扫",
    "扫描二维码以完成支付": "扫描二维码以完成支付",
    "榜单": "榜单",
    "MANA榜单": "MANA榜单",
    "每天上午10:00点前更新": "每天上午10:00点前更新",
    "周榜": "周榜",
    "月榜": "月榜",
    "总榜": "总榜",
    "MANA榜单周榜 TOP10": "MANA榜单周榜 TOP10",
    "MANA榜单周榜 TOP": "MANA榜单周榜 TOP",
    "MANA榜单月榜 TOP30": "MANA榜单月榜 TOP30",
    "MANA榜单月榜 TOP": "MANA榜单月榜 TOP",
    "MANA榜单总榜 TOP100": "MANA榜单总榜 TOP100",
    "MANA榜单总榜 TOP": "MANA榜单总榜 TOP",
}


// WEBPACK FOOTER //
// ./src/languages/cn/live.js